export const DEFAULT_THEME = {
  "id": "1",
  "name": "Default theme",
  "brand_name": "maru",
  "dark": false,
  "icon_base": "1rem",
  "font": {
    "name": "Lato",
    "mode": "css",
    "url": "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap",
    "size": "1rem"
  },
  "color_primary_main": "#269D80",
  "color_primary_deep": "#186B57",
  "color_primary_dark": "#0F4C3D",
  "color_primary_logo": "#6DAADC",
  "color_primary_light": "#C8DFFB",
  "color_primary_active": "#EBFBF7",
  "color_primary_white": "#FFFFFF",
  "color_grey_dark": "#323945",
  "color_grey_deep": "#575d68",
  "color_grey_medium": "#69758A",
  "color_grey_accent": "#BCC3D5",
  "color_grey_blue": "#D5DEEE",
  "color_grey_strokes": "#EBEFF4",
  "color_grey_mid_light": "#F3F5F9",
  "color_grey_light": "#F9FAFD",
  "color_grey_light_blue": "#E1EAFB",
  "color_semantic_light_red": "#FEF4F4",
  "color_semantic_red": "#DA0505",
  "color_semantic_accent_green": "#27D739",
  "color_semantic_accent_light_green": "#E9FBEB",
  "color_semantic_accent_yellow": "",
  "logo": ""
};
